import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [branches, setBranches] = useState([]);
  const [activeBranch, setActiveBranch] = useState(localStorage.getItem("mmm_branch") || "");

  const loadMe = useCallback(async () => {
    const token = localStorage.getItem("mmm_token");
    if (!token) { setLoading(false); return; }
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
      const b = await api.get("/branches");
      setBranches(b.data.items || []);
    } catch (e) {
      localStorage.removeItem("mmm_token");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { loadMe(); }, [loadMe]);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("mmm_token", data.access_token);
    setUser(data.user);
    const b = await api.get("/branches");
    setBranches(b.data.items || []);
    return data.user;
  };

  const logout = () => {
    localStorage.removeItem("mmm_token");
    localStorage.removeItem("mmm_branch");
    setUser(null);
    window.location.href = "/login";
  };

  const chooseBranch = (id) => {
    setActiveBranch(id);
    if (id) localStorage.setItem("mmm_branch", id);
    else localStorage.removeItem("mmm_branch");
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, logout, branches, setBranches, activeBranch, chooseBranch, refresh: loadMe }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
